import { messaging } from "@/firebase-messaging-sw";
import axios from "axios";
import { getToken, onMessage } from "firebase/messaging";
import QueryString from "qs";
import { create } from "zustand";

const params = QueryString.stringify({
  pagination: {
    page: 1,
    pageSize: 1000,
  },
});

const useAuthStore = create((set, get) => ({
  init: false,
  user: {},
  permission: "user",
  pageSize: 15,
  companyList: [],
  totalUserWithdrawPoints: 0, // 30000 이상인 유저들의 총 포인트
  hasAccountingPermission: false,
  adminList: [],
  distancePriceList: [],

  handleLogout: () => {
    delete axios.defaults.headers.common["Authorization"];
    localStorage.removeItem("jwt");
    sessionStorage.clear();
    set({ user: {}, init: true, companyList: [], distancePriceList: [], hasAccountingPermission: false });
  },

  updateCompanyList: async () => {
    const compParams = {
      pagination: {
        page: 1,
        pageSize: 1000,
      },
      populate: "manager",
    };
    const { data } = await axios({
      url: `/companies?${QueryString.stringify(compParams)}`,
    });
    set({ companyList: data?.data || [] });
  },

  updateUserTotalPoints: async () => {
    const { data } = await axios({ url: `/users?${params}` });
    const totalUserWithdrawPoints = data.reduce((acc, cur) => {
      if (cur.points && cur.points > 30000 && cur.permission === "user")
        return acc + Number(cur.points);
      return acc;
    }, 0);

    set({ totalUserWithdrawPoints });
  },

  updateAdminList: async () => {
    const { data } = await axios({
      url: `/users?${QueryString.stringify({ filters: { permission: { $in: ["admin", "partner"] } } })}`,
    });
    set({ adminList: data || [] });
  },

  getWebPushToken: async () => {
    console.log("권한 요청 중...");
    // check if browser supports notification
    if (!("Notification" in window)) {
      console.log("This browser does not support notifications.");
      return;
    }

    const permission = await Notification.requestPermission();

    if (permission === "denied") {
      console.log("알림 권한 허용 안됨");
      return;
    }

    console.log("알림 권한이 허용됨");

    const token = await getToken(messaging, {
      vapidKey:
        "BFHh8siDqrMi2OQqFbloGMA2mQPqGL9x5ficA1AGMryt96iOYSWOFGLhovpQ4kmgcqbhxrCU2bOlMILQhqQWbO0",
    });

    if (token) {
      // alert(token);
      console.log("token: ", token);
    } else console.log("Can not get Token");

    onMessage(messaging, (payload) => {
      console.log("메시지가 도착했습니다.", payload);
      // ...
    });
  },

  getDistancePrice: async () => {
    const { data } = await axios({ url: "/distance-price" });
    set({ distancePriceList: data });
  },

  handleAuthInit: async (jwt) => {
    try {
      axios.defaults.headers.common["Authorization"] = `Bearer ${jwt}`;
      localStorage.setItem("jwt", jwt);
      const { data } = await axios({
        url: "/users/me?populate=company,partnerCompanies",
      });
      console.log("USER INIT => ", data.id);
      if (data.permission === "partner" || data.permission === "freelancer") {
        set({
          user: data,
          permission: data.permission,
          companyList:
            data.partnerCompanies.map((x) => ({
              id: x.id,
              attributes: { ...x },
            })) || [],
          adminList: [{ ...data, id: data.id }],
        });
        // get().updateAdminList();
        get().getDistancePrice();
      } else {
        get().updateCompanyList();
        get().updateAdminList();
        set({ user: data, permission: data?.permission || "user" });
        get().getDistancePrice();
        // 회계관리 권한이 있는지 확인
        // 김현일 삭제 data.id === 3 ||
        if (data.id === 1 || data.id === 5 || data.id === 87) {
          set({ hasAccountingPermission: true });
        }
      }

      get().updateUserTotalPoints();
      // get().getWebPushToken();
    } catch (e) {
      console.log("start error", e);
      delete axios.defaults.headers.common["Authorization"];
      localStorage.removeItem("jwt");
      set({ user: {}, init: true });
    } finally {
      set({ init: true });
    }
  },

  refetchUser: async () => {
    const { data } = await axios({ url: "/users/me" });
    set({ user: data, permission: data?.permission || "admin" });
  },
}));

export default useAuthStore;
